// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"8744d8d7","268":"fe8fc091","390":"e820b9a0","501":"8931372a","528":"e1badafb","746":"6b6d3b65","787":"4a3a2996","946":"1907acdc"}[chunkId] + ".chunk.js";
};